export const countObjectsWithFilledFields = (objects, fieldNames) =>
  objects.reduce((count, current) => {
    for (const fieldName of fieldNames) {
      if (!current[fieldName]) {
        return count;
      }
    }
    return count + 1;
  }, 0);
